/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function (Flits) {
  /* To load js in all pages */
  Flits.LoadStyleScript(
    "socialLoginJs",
    window.flitsObjects.allCssJs.socialLoginJs.url
  );

  Flits(document).on("Flits:SocialLoginAutomaticCode:Loaded", function (t) {
    var i = t.detail;
    i.parent
      .find('[data-flits="social-login-added"] .social-login-container')
      .append(i.cloneNode);
  });
})(Flits);
